import React, { useEffect, useState } from "react";
import CategorySelector from "./Main";
import { GET } from "../../utils/requests";

const ACCOUNT_ID = 1;
const DEFAULT_CATEGORY_ID = 45;

const Demo = () => {
  const [value, setValue] = useState(null)
  const [tree_options, setTreeOptions] = useState(null)

  useEffect(() => {
    console.log(value)
    GET({
      url: `/references/categories.json?account_id=${ACCOUNT_ID}`,
      success: (data) => {
        setTreeOptions(data)
      }
    })
  }, [])

  return (
    <>
      {tree_options && <>
        <CategorySelector
          default_value={DEFAULT_CATEGORY_ID}
          tree_options={tree_options}
          value={value}
          onChange={(val) => setValue(val)}
        />
        <br/>
        {value && <ul>
          <li>ID: {value.id}</li>
          <li>Name: {value.name}</li>
        </ul>}
      </>}
    </>
  )
}

export default Demo;
